<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<choose-geographical-locations
				v-model="old"
				:readonly="true"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-geographical-locations
				v-model="current"
				:readonly="true"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";
	import ChooseGeographicalLocations from "../components/ChooseGeographicalLocations";

	export default {
		name: "CompareLocations",
		components: {ChooseGeographicalLocations, NewVersionMarker, OldVersionMarker},
		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
		}
	};
</script>

<style scoped>

</style>
